__webpack_require__.p = "/inspir8tion/";